<template>
  <div>
    <!--Stats cards-->
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-6" v-for="stats in statsCards" :key="stats.type">
        <stats-card 
                  v-if="stats.permissions.includes(userType)" 
                  :type="stats.type"
                  :icon="stats.icon"
                  :small-title="stats.title"
                  :title="stats.value">
        </stats-card>
      </div>
    </div>

  </div>
</template>
<script>
import StatsCard from 'src/components/UIComponents/Cards/StatsCard';
import Resource from "@/util/Api/resource.js";
const countResource = new Resource("post/count/all");
  export default {
    components: {
      StatsCard,
    },
    data () {
      return {
        countData:[],
        statsCards: [],
        dataFormat: {
            type: '',
            icon: '',
            title: '',
            value: '',
            permissions: []
        },
        user: localStorage.getItem("user"),
        userType:'',
      }
    },

    methods: {

      getCountData() {

        countResource.list({})
         .then((response) => {

            this.countData = response.data;

            this.countData.forEach((element) => {
                this.dataFormat = [];

                if(element.name.toLowerCase() === "trainers"){
                    this.dataFormat.type = 'primary';
                    this.dataFormat.icon = 'fa fa-users';
                    this.dataFormat.title = element.name;
                    this.dataFormat.value = element.total.toString();
                    this.dataFormat.permissions = ['Super Admin', 'Admin', 'Manager'];
                } else if(element.name.toLowerCase() === "farmers"){
                    this.dataFormat.type = 'success';
                    this.dataFormat.icon = 'fa fa-user';
                    this.dataFormat.title = element.name;
                    this.dataFormat.value = element.total.toString();
                    this.dataFormat.permissions = ['Super Admin', 'Admin', 'Manager', 'Trainer'];
                } else if(element.name.toLowerCase() === "harvests"){
                    this.dataFormat.type = 'warning';
                    this.dataFormat.icon = 'fa fa-crop';
                    this.dataFormat.title = element.name;
                    this.dataFormat.value = element.total.toString();
                    this.dataFormat.permissions = ['Super Admin', 'Admin', 'Manager', 'Trainer'];
                } else if(element.name.toLowerCase() === "fields"){
                    this.dataFormat.type = 'info';
                    this.dataFormat.icon = 'fa fa-circle';
                    this.dataFormat.title = element.name;
                    this.dataFormat.value = element.total.toString();
                    this.dataFormat.permissions = ['Super Admin', 'Admin', 'Manager'];
                }

                if(this.dataFormat.title){
                   this.statsCards.push(this.dataFormat);
                }

            });

         }).catch((error) => {
            console.log(`Error occurred getting count data ${error}`);
         });

      }

    },

    mounted() {
       this.authUser = JSON.parse(this.user);
       this.userType = this.authUser[0].roleName;
       this.getCountData();
    },

  }

</script>
